import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { injectIntl, FormattedMessage } from "react-intl";
import { LocaleConsumer } from "contexts/locale-context";
import { fromRenderProps, compose } from "recompose";
import withLocale from "system/withLocale";
import Family from "./Family";
import familyClose from "images/family_close.png";
import familyOpen from "images/family_open.png";
import styled from "styled-components";

const FooterBox = styled.div`
  height: 140px;
  background: #363636;
  color: #fff;
  font-size: 12px;

  .inr {
    display: flex;
    align-items: center;
    line-height: 1.3rem;
  }
`;
const FamilyWrap = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  width: 172px;
  height: 30px;
  padding: 5px 10px;
  background: #292929;
  box-sizing: border-box;
  cursor: pointer;
`;
const Txt = styled.p`
  color: #fff;
  font-size: 12px;
`;

const ImgWrap = styled.div`
  position: absolute;
  top: 12px;
  right: 10px;
`;

class Footer extends Component {
  state = {
    showFamily: false
  };

  toggleFamily = () => {
    this.setState({
      showFamily: !this.state.showFamily
    });
  };

  // 빈 영역 클릭시 패밀리사이트 닫기
  handleClickOutside = e => {
    if (!this.family.contains(e.target)) {
      this.setState({
        showFamily: false
      });
    }
  };

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.showFamily !== this.state.showFamily;
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside, false);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, false);
  }

  render() {
    const { showFamily } = this.state;
    const { lang } = this.props;
    return (
      <FooterBox>
        <div className="inr">
          <div>
            <FormattedMessage id={"footer.addr"} />
            <br />
            TEL 02-741-4221 | EMAIL snuhctc@snu.ac.kr
            <br />© SEOUL NATIONAL UNIVERSITY HOSPITAL CLINICAL TRIALS CENTER
            ALL RIGHTS RESERVED
          </div>
          <FamilyWrap>
            <Txt
              onClick={this.toggleFamily}
              ref={node => {
                this.family = node;
              }}
            >
              <FormattedMessage id={"footer.familySite"} />
            </Txt>
            <ImgWrap>
              {showFamily ? (
                <img src={familyClose} alt="닫기" />
              ) : (
                <img src={familyOpen} alt="열기" />
              )}
            </ImgWrap>
            {showFamily && <Family langData={lang} />}
          </FamilyWrap>
        </div>
      </FooterBox>
    );
  }
}

// export default Footer;

const enhance = compose(withRouter, injectIntl, withLocale);

export default fromRenderProps(LocaleConsumer, ({ state, actions }) => ({
  locale: state.locale,
  setValue: actions.setValue
}))(enhance(Footer));
